export default "__VITE_ASSET__41f45fb0__"